import { render, staticRenderFns } from "./VideoPlayerPage.vue?vue&type=template&id=4750a0a4&scoped=true"
import script from "./VideoPlayerPage.vue?vue&type=script&lang=js"
export * from "./VideoPlayerPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4750a0a4",
  null
  
)

export default component.exports